'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var ipfsUnixfsExporter = require('ipfs-unixfs-exporter');

var errCode = require('err-code');

var utils = require('../utils.js');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var cid = require('multiformats/cid');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

function createLs(_ref) {
  var repo = _ref.repo,
      preload = _ref.preload;

  function ls(_x) {
    return _ls.apply(this, arguments);
  }

  function _ls() {
    _ls = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ipfsPath) {
      var options,
          legacyPath,
          pathComponents,
          ipfsPathOrCid,
          file,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          child,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              legacyPath = utils.normalizeCidPath(ipfsPath);
              pathComponents = legacyPath.split('/');

              if (options.preload !== false) {
                preload(cid.CID.parse(pathComponents[0]));
              }

              ipfsPathOrCid = cid.CID.asCID(legacyPath) || legacyPath;
              _context.next = 7;
              return _awaitAsyncGenerator(ipfsUnixfsExporter.exporter(ipfsPathOrCid, repo.blocks, options));

            case 7:
              file = _context.sent;

              if (!(file.type === 'file')) {
                _context.next = 12;
                break;
              }

              _context.next = 11;
              return utils.mapFile(file);

            case 11:
              return _context.abrupt("return");

            case 12:
              if (!(file.type === 'directory')) {
                _context.next = 43;
                break;
              }

              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 15;
              _iterator = _asyncIterator(file.content());

            case 17:
              _context.next = 19;
              return _awaitAsyncGenerator(_iterator.next());

            case 19:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 26;
                break;
              }

              child = _step.value;
              _context.next = 23;
              return utils.mapFile(child);

            case 23:
              _iteratorAbruptCompletion = false;
              _context.next = 17;
              break;

            case 26:
              _context.next = 32;
              break;

            case 28:
              _context.prev = 28;
              _context.t0 = _context["catch"](15);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 32:
              _context.prev = 32;
              _context.prev = 33;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 37;
                break;
              }

              _context.next = 37;
              return _awaitAsyncGenerator(_iterator.return());

            case 37:
              _context.prev = 37;

              if (!_didIteratorError) {
                _context.next = 40;
                break;
              }

              throw _iteratorError;

            case 40:
              return _context.finish(37);

            case 41:
              return _context.finish(32);

            case 42:
              return _context.abrupt("return");

            case 43:
              throw errCode__default["default"](new Error("Unknown UnixFS type ".concat(file.type)), 'ERR_UNKNOWN_UNIXFS_TYPE');

            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[15, 28, 32, 42], [33,, 37, 41]]);
    }));
    return _ls.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(ls);
}

exports.createLs = createLs;